<template>
    <div class="products-list__item">
        <div class="product-card">
            <div class="product-card__image">
                <div class="image image--type--product">
                    <router-link :to="'/kit-group/' + product.manufacturer + '/' + product.sku" class="image__body">
                        <img class="image__tag" :src="resource_img" alt="" />
                        <!-- <cld-image publicId="v1629128197" /> -->
                        <!-- <cld-image publicId="DMS-Auto/Manufacturers/ACDelco.jpg" ></cld-image> -->
                    </router-link>
                </div>
                <div class="status-badge status-badge--style--success product-card__fit status-badge--has-icon status-badge--has-text">
                    <div class="status-badge__body">
                        <div class="status-badge__icon">
                            <svg width="13" height="13"><path d="M12,4.4L5.5,11L1,6.5l1.4-1.4l3.1,3.1L10.6,3L12,4.4z"></path></svg>
                        </div>
                        <div class="status-badge__text">Part Fit for 2018 Chevrolet Silverado</div>
                        <div class="status-badge__tooltip" tabindex="0" data-toggle="tooltip" title="" data-original-title="Part Fit for 2011 Ford Focus S"></div>
                    </div>
                </div>
            </div>
            <div class="cart-table__quantity-search-results product-card__stock-text-search-whi-product-qty">
                <base-quantity-input v-model="quantity"></base-quantity-input>
            </div>
            <button class="product-card__addtocart-icon product-card__addtocart-icon-whi product-card__stock-text-search-whi-product-btn-cart" type="button" aria-label="Add to cart" @click="kitToCart">
                <svg width="20" height="20">
                    <circle cx="7" cy="17" r="2"></circle>
                    <circle cx="15" cy="17" r="2"></circle>
                    <path
                        d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
                        V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
                        C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"
                    ></path>
                </svg>
            </button>
            <button class="product-card__addtocart-full" type="button">Add to cart</button>
            <div class="product-card__info">
                <div class="product-card__name">
                    <div>
                        <div class="text-cart-item-number"><font class="text-cart-item-number">Item: {{ product.sku }}</font></div>
                        <router-link :to="'/kit-group/' + product.manufacturer + '/' + product.sku" class="cart-table__product-name">Engine Rebuild Kit - {{product.description}}</router-link>
                        <div class="text-kit-description">
                            <!-- <font class="text-kit-description">
                                PERFORMANCE - Chevy 350 67-79 315HP <br />
                                HYPER COATED FLAT TOP PISTON, RV CAM-204-214; .420-.443"<br />
                                ROLLER TIMING AND HI-PERF OPTIONS
                            </font> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-card__footer">
                <div class="product-card__prices">
                    <div class="product-card__price product-card__price--current">Price: {{toUSD(extended_price)}}</div>
                    <div class="product-card__price product-card__price--old" v-if="product.list_price > 0">List: {{toUSD(product.list_price)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Price from '../../../mixins/price.js';
import { mapGetters } from 'vuex';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';
import axiosvl from "../../../axios/axios-vl.js";

export default {
    data() {
        return {
            quantity : 1,
            resource_img : '',
            kit_master: {},
            kit_gtotal: 0,
            kitc_qty: 0,
            kit_items: [],
        }
    },
    mixins: [Price],
    computed: {
        ...mapGetters([
        'storeCatalog', 
        'customerIndicator',
        'storefrontAttributes'
        ]),

        extended_price(){
            const price = this.product.extended_price * this.quantity;
            return price;
        },
    },
    props : {
        product : {
            type : Object,
            required: true
        },
        sourcePage: {
            type: String
        },
        searchBy : {
                type : String
        }
    },
    methods: {

        async fetchKitInfo() {
            return await axiosvl.post(this.$store.getters['api/kit_master_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "KMMMFG": { "value": this.product.manufacturer },
                        "KMMITM": { "value": this.product.IMITMC },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const KITPARTS = response.data.webroutine.lists.KITPARTS.entries;
                const ITMSIZES = response.data.webroutine.lists.ITMSIZES.entries;
                const PARTLOC = response.data.webroutine.lists.PARTLOC.entries;

                // const MPARTS = response.data.webroutine.lists.MPARTS.entries;
                this.kit_sizes = ITMSIZES;
                const kitm_loc = PARTLOC.find(loc => (loc.EIITMC == this.product.IMITMC && loc.EIMFGC == this.product.manufacturer));
                // console.log(kitm_loc);
                const clApi = new CloudinaryApi;
                clApi.item_sku = this.product.IMITMC;
                clApi.manufacturer_code = this.product.manufacturer;

                return clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                    let kitm_image = '';
                    if(imgURL){
                        kitm_image = imgURL;
                    }else{
                        kitm_image = GCONST.IMAGE_PLACEHOLDER;
                    }

                    this.kit_master = {
                        ID: this.product.IMITMC,
                        item: this.product.IMITMC,
                        desc: fields.KITDSC.value,
                        long_desc: fields.DDTXT0K.value + ' ' + fields.DDTXT1K.value + ' ' + fields.DDTXT2K.value + ' ' + fields.DDTXT3K.value + ' ' + fields.DDTXT4K.value + ' ' + fields.DDTXT5K.value + ' ' + fields.DDTXT6K.value + ' ' + fields.DDTXT7K.value + ' ' + fields.DDTXT8K.value + ' ' + fields.DDTXT9K.value,
                        manufacturer: this.product.manufacturer,
                        manufacturername: '',
                        yourprice: fields.KITPRC.value,
                        corecharge: fields.KITCOR.value,
                        listprice: fields.KITLST.value,
                        carrier: '',

                        // locations
                        locationid: fields.CMDLOC.value,
                        locationname: kitm_loc.LCNAME,
                        locationcity: kitm_loc.LCLOCC,
                        locationstate: kitm_loc.LCTAXC,

                        XRITMC: '',
                        XRMFGC: '',
                        // xref_mfg_desc: (fields.XRMFGC.value != '') ? xref_mfg_desc.MFG_DESC : '',
                        IMIGSA: fields.KITIGSA.value,
                        IMISVALID: '',
                        image: kitm_image,
                        kit_items: [],
                    };
                    // console.log(this.kit_master);
                    this.kit_items = [];
                    
                    KITPARTS.forEach(kit => {
                        // const sizes = ITMSIZES.filter(s => s.QITEMNUM == kit.EIITMC && s.QSIZEITM != '' && s.QMFR == kit.EIMFGC);
                        // console.table(sizes);
                        const kitc_loc = PARTLOC.find(loc => (loc.EIITMC == kit.EIITMC && loc.EIMFGC == kit.EIMFGC));
                        // console.log(kit);
                        // add substitutes to the separate var array
                        if(kit.CINFO == 'SUBSTITUTE'){
                            return;
                        }

                        if(kit.KCRQTY == 0){
                            return;
                        }

                        this.kitc_qty += this.quantity * kit.KCRQTY;
                        
                        this.kit_items.push({
                            info: kit.CINFO,
                            item: kit.EIITMC,
                            desc: kit.IMDESC,
                            manufacturer: kit.EIMFGC,
                            manufacturername: kit.MCNAME,

                            yourprice: kit.EIEXCP,
                            corecharge: kit.EICORP,
                            listprice: kit.EILSTP,

                            backorder: '',
                            req_qty: kit.KCRQTY,
                            quantity: this.quantity * kit.KCRQTY,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? kit.QTYAVL : kit.TOTOH,
                            carrier: '',

                            // locations
                            locationid: kitc_loc.ILLOC,
                            locationname: kitc_loc.LCNAME,
                            locationcity: kitc_loc.LCLOCC,
                            locationstate: kitc_loc.LCTAXC,
                            
                            XRITMC: kit.XRITMC,
                            XRMFGC: kit.XRMFGC,
                            IMIGSA: kit.IMIGSA,
                            IMISVALID: kit.IMISVALID,
                            KCSEQN: kit.KCSEQN,
                            EKKITF: 'C',
                            image: GCONST.IMAGE_PLACEHOLDER,

                            sizes: [],
                            alternatives: [],
                            origItem: '',
                        });
                    
                    });

                    this.kit_items.forEach(kit => {
                        const linetotal = (this.quantity * kit.req_qty) * kit.yourprice;
                        kit.linetotal = linetotal;
                        const clApi = new CloudinaryApi;
                        clApi.item_sku = kit.item;
                        clApi.manufacturer_code = kit.manufacturer;

                        clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                            kit.image = imgURL;
                            if(imgURL){
                                kit.image = imgURL;
                            }else{
                                kit.image = GCONST.IMAGE_PLACEHOLDER;
                            }
                        });

                        this.kit_master.kit_items.push(kit);
                        this.kit_gtotal += linetotal;
                    });

                    return this.kit_master;
                });
                
                // this.kit_master.kit_items = this.kit_items;

                // console.log(this.kit_master);
                // return this.kit_master;
             })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        /**
         * KIT MASTER to add to the cart
         */
        kitToCart() {

            this.fetchKitInfo().then((res) => {
                console.log(res);
                // get the kit item components that has quantity > 0
                // const kitc_items = this.kit_items.filter(c => c.quantity > 0);

                // loop through kit items
                // check in changed sizes if the item has change on sizes

                const kit = {
                    kitnumber   : this.product.IMITMC,
                    mfgcode     : this.product.manufacturer,
                    EKKITF      : 'M',
                    kitqy       : this.quantity,
                    quantity    : this.kitc_qty,
                    backorder   : '',
                    corecharge  : this.kit_master.corecharge,
                    yourprice   : this.kit_master.yourprice,
                    kit_gtotal  : this.kit_gtotal,
                    desc        : this.kit_master.desc,
                    image       : this.kit_master.image,
                    sku         : this.kit_master.item,
                    carrier     : '',

                    locationid      : this.kit_master.locationid,
                    locationname    : this.kit_master.locationname,
                    locationcity    : this.kit_master.locationcity,
                    locationstate   : this.kit_master.locationstate,

                    kit_items   : this.kit_items,
                };
                // console.log(kit);
                // if(kit != undefined){
                //     return;
                // }
                this.$store.dispatch("cart/kitToCart", kit);
            });

            
        },
    },

    created() {
        console.log(this.product);

        const clApi = new CloudinaryApi;
        clApi.item_sku = this.product.IMITMC;
        clApi.manufacturer_code = this.product.manufacturer;
        
        clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
            if(imgURL){
                this.resource_img = imgURL;
            }else{
                this.resource_img = GCONST.IMAGE_PLACEHOLDER;
            }
        });
    }
}
</script>